import React from "react";
import styles from "./DeleteModal.module.scss";
import Modal from "../modal/Modal";

interface ModalProps {
  deleteModal: boolean;
  onClose: () => void;
  title?: string;
  onSubmit?: () => void;
}

const DeleteModal: React.FC<ModalProps> = ({
  deleteModal,
  onClose,
  title,
  onSubmit,
}) => {
  return (
    <Modal isOpen={deleteModal} onClose={onClose} onSubmit={onSubmit}>
      {title && <h2 className={styles.modalTitle}>{title}</h2>}
    </Modal>
  );
};

export default DeleteModal;
